import { useFlags } from 'launchdarkly-react-client-sdk';
import mockedFlags from 'src/mocks/feature_flag_mock.json';

// Change here to true to use mocked flags in development environment
const SHOULD_USE_MOCK = false;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useFlagsWrapper = (overrideUseMock = SHOULD_USE_MOCK) => {
  const flags = useFlags();
  if (process.env.NODE_ENV === 'development' && overrideUseMock) {
    // Go to 'src/mocks/feature_flag_mock.json' to change the mock values
    return mockedFlags;
  }
  return flags;
};

export default useFlagsWrapper;
